import axios from 'axios'
import { config } from '../constants'

const BASE_URL_GEMVISION = `${config.BASE_URL}/gemvision`

export const getApiKey = async (parameterName) => {
  try {
    const key = await axios.post(`${BASE_URL_GEMVISION}/recaptcha`, { parameterName })
    return key.data
  } catch (error) {
    console.error(error.message)
  }
}
